// extracted by mini-css-extract-plugin
export default {"red":"login_red__62DKi","green":"login_green__dGWhO","border":"login_border__v62C7","now":"login_now__OCpPo"};